import { mockEntityDetail } from '@web-config-app/mock-data';
import type { UseEntityOperationsResult } from '@web-config-app/core-react';
import type { ValidationEndpointResponse } from '@web-config-app/core';

export const mockUseEntityGetResult = {
  dataUpdatedAt: 0,
  error: null,
  errorUpdatedAt: 0,
  failureCount: 0,
  failureReason: null,
  fetchStatus: 'idle',
  isError: false,
  isFetched: true,
  isFetchedAfterMount: true,
  isFetching: false,
  isInitialLoading: false,
  isLoading: false,
  isLoadingError: false,
  isPaused: false,
  variables: undefined,
  context: undefined,
  isPending: false,
  isPlaceholderData: false,
  isRefetchError: false,
  isRefetching: false,
  isStale: false,
  isSuccess: false,
  errorUpdateCount: 0,
  status: 'success',
  refetch: () => Promise.resolve({}),
  data: mockEntityDetail,
} as const;

export const mockUseEntityUpdateResult = {
  ...mockUseEntityGetResult,
  mutate: () => {},
  mutateAsync: () => Promise.resolve({}),
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: undefined,
  error: null,
  reset: () => {},
  isIdle: true,
  status: 'idle',
  submittedAt: 0,
  enableAction: true,
} as const;

export const mockUseEntityValidateResult = {
  ...mockUseEntityGetResult,
  mutate: () => {},
  mutateAsync: () =>
    Promise.resolve({
      data: {
        id: 'validation-id',
        type: 'config-entity-validation',
        attributes: { status: 'success' },
      },
    } as ValidationEndpointResponse),
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: undefined,
  error: null,
  reset: () => {},
  isIdle: true,
  status: 'idle',
  submittedAt: 0,
  enableAction: true,
} as const;

export const mockUseEntityCreateResult = {
  ...mockUseEntityGetResult,
  mutate: () => {},
  mutateAsync: () => {},
  reset: () => {},
  data: undefined,
  variables: undefined,
  isIdle: false,
  submittedAt: 0,
  isPending: true,
  status: 'pending',
  enableAction: true,
} as const;

export const mockUseEntityCloneResult = {
  ...mockUseEntityCreateResult,
  enableAction: true,
} as const;

export const mockUseEntityDeepCloneResult = {
  enableAction: true,
} as const;

export const mockOperations = {
  get: mockUseEntityGetResult,
  update: mockUseEntityUpdateResult,
  create: mockUseEntityCreateResult,
  republish: mockUseEntityUpdateResult,
  publish: mockUseEntityUpdateResult,
  unpublish: mockUseEntityUpdateResult,
  archive: mockUseEntityUpdateResult,
  unarchive: mockUseEntityUpdateResult,
  clone: mockUseEntityCloneResult,
  deepClone: mockUseEntityDeepCloneResult,
  validate: mockUseEntityValidateResult,
} as unknown as UseEntityOperationsResult;
